import Vue from 'vue';
import __vue_component__ from '../icons/FlagIcon.vue.js';
import __vue_component__$1 from '../icons/Icon.vue.js';

var script = Vue.extend({
    props: {
        selectedItem: {
            type: Object,
            required: true,
        },
        isSidebarExpanded: {
            type: Boolean,
            required: true,
        },
        showFilterIcon: {
            type: Boolean,
            default: true,
        },
    },
    destroyed: function () {
        this.$emit('onDestroyed');
    },
    components: {
        FlagIcon: __vue_component__,
        Icon: __vue_component__$1,
    }
});

export default script;
